import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LinearScale from '@mui/icons-material/LinearScale';
import Repeat from '@mui/icons-material/Repeat';
import ListAlt from '@mui/icons-material/ListAlt';
import { ServiceContext } from 'providers/ServiceProvider';
import { Origination } from 'constants/contexts';
import { IconButton } from '@totalsoft/rocket-ui';
import FlexBox from 'components/common/FlexBox';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_DOCUMENT_TYPE_PROPERTIES_READ } from 'constants/rightsCodes';

const DocumentTypeItem = ({ data }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();
  const [activeService] = useContext(ServiceContext);
  const canRead = usePermission(ADMIN_DOCUMENT_TYPE_PROPERTIES_READ);

  const handleEdit = useCallback(
    editType => () => {
      historyContext.push(`/documentTypes/${data.id}/${editType}`);
    },
    [historyContext, data]
  );

  return (
    <TableRow hover key={data.code}>
      <TableCell>{data.code}</TableCell>
      <TableCell>{data.name}</TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton
            size='small'
            color='primary'
            variant='text'
            tooltip={t('Tooltips.DocumentStates')}
            onClick={handleEdit('allowedStates')}
          >
            <LinearScale fontSize='small' />
          </IconButton>
          <IconButton
            size='small'
            color='primary'
            variant='text'
            tooltip={t('Tooltips.StateTransitions')}
            onClick={handleEdit('stateTransitions')}
          >
            <Repeat fontSize='small' />
          </IconButton>
          {activeService?.route === Origination.serviceRoute && canRead && (
            <IconButton
              size='small'
              color='primary'
              variant='text'
              onClick={handleEdit('documentTypeProperties')}
              tooltip={t('Tooltips.DocumentTypeProperties')}
            >
              <ListAlt fontSize='small' />
            </IconButton>
          )}
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

DocumentTypeItem.propTypes = {
  data: PropTypes.array.isRequired
};

export default DocumentTypeItem;
